import 'react-toastify/dist/ReactToastify.css';

import { toast } from 'react-toastify';

import * as storage from '../../../../../services/storage';
import CadastrarCaixaTypes from './types';

const INITIAL_STATE = {
    tipo: '',
    dados: '',
    caixaOriginal: '',
    caixaCopia: '',
    finalizarImpressao: false,
    finalizarReimpressao: false,
    selectedCaixaReimpressao: {}
};

const defaultErrorMessage = "Houve um problema com a sua requisição";

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case CadastrarCaixaTypes.CLEAR:
            return INITIAL_STATE

        case CadastrarCaixaTypes.SEQUENCIAL_ORIGINAL_REQUEST:
            return {
                ...state,
                nomeAplicacao: action.payload.nomeAplicacao,
                loading: true,
            };

        case CadastrarCaixaTypes.SEARCH_CAIXA_REQUEST:
        case CadastrarCaixaTypes.SEQUENCIAL_COPIA_REQUEST:
            return {
                ...state,
                nomeAplicacao: action.payload.nomeAplicacao,
                loading: true,
            };

        case CadastrarCaixaTypes.SEQUENCIAL_SUCCESS:

            const caixaNumero = action.payload.caixa;
            const caixaTipo = action.payload.tipo;
            const nomeAplicacao = action.payload.nomeAplicacao || '';

            let result = {
                ...state,
                loading: false, error: false
            }

            if(caixaTipo === "caixaoriginal") {
                storage.setItem(`sequencialCaixaOriginal${nomeAplicacao}`, caixaNumero);
                result.caixaOriginal = caixaNumero
            } else if (caixaTipo === "caixacopia") {
                storage.setItem(`sequencialCaixaCopia${nomeAplicacao}`, caixaNumero);
                result.caixaCopia = caixaNumero
            }

            return result;
    
        case CadastrarCaixaTypes.SEARCH_CAIXA_SUCCESS:

            let finalizarReimpressao = false;
            let caixa = {}

            if(action.payload.length > 0) {
                toast.success('Reimpressão realizada com sucesso');

                caixa = action.payload[0]
                finalizarReimpressao = true;
            } else {
                toast.error("Caixa não encontrada, faça a pesquisa novamente.")
            }

            return {
                ...state,
                selectedCaixaReimpressao: caixa,
                finalizarReimpressao: finalizarReimpressao,
                loading: false, error: false
            }

        case CadastrarCaixaTypes.INSERT_REQUEST:
            return {
                ...state,
                loading: true 
            };
    
        case CadastrarCaixaTypes.INSERT_SUCCESS:

            toast.success('Impressão realizada com sucesso');

            return {
                ...state,
                finalizarImpressao: true,
                loading: false, error: false
            }

        case CadastrarCaixaTypes.REQUEST_FAILURE:
            toast.error(defaultErrorMessage)
            return { ...state, loading: false, error: true }
         
        case CadastrarCaixaTypes.TIPO:

            let tipo =  action.payload.tipo;

            return {
                ...state,
                tipo
            };

        case CadastrarCaixaTypes.CAPA_SEARCH:
            return {
                ...state,
                dados: action.payload.dados
            };
        case CadastrarCaixaTypes.CAPA_REQUEST:
        case CadastrarCaixaTypes.CAPA_PRINT:
            return {
                ...state
            };

        default:
            return state;
    }
}